import { Typography } from '@dg-shared/index'
import React, { FC } from 'react'
import { getPolicyDates } from '@dg-util'
import { PolicyV2Type } from '../../types/ApiV2'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles()((theme: Theme) => ({
  date: {
    marginTop: theme.spacing(2),
    color: theme.brand.colors.textSecondary,
    ...theme.brand.assets.layout?.PolicyInsuranceDatesText,
  },
}))

const PolicyInsuranceDatesText: FC<{
  policy: Partial<PolicyV2Type>
  classDate?: string
}> = ({ policy, classDate }) => {
  const { classes, cx } = useStyles()

  if (!policy) {
    return null
  }

  const { dateFrom, dateTo } = getPolicyDates(policy as PolicyV2Type)

  // `date` wins over the caller's class, as it did on v4 (e.g. its colour over BaseCard's subtitle).
  return (
    <Typography className={cx(classDate, classes.date)} testId={'policy-date'}>
      {`${dateFrom} - ${dateTo ? dateTo : '...'}`}
    </Typography>
  )
}

export default PolicyInsuranceDatesText
